{
  "actions": {
    "cancel": "إلغاء"
  },
  "status": {
    "DRAFT": "مسودة",
    "SUBMITTED": "بانتظار الاعتماد",
    "APPROVED": "معتمد",
    "RETURNED": "مُرجَع"
  },
  "myTime": {
    "title": "وقتي",
    "off": "تسجيل الوقت غير مفعّل في شركتك",
    "offBody": "يمكن للمسؤول تفعيله من الإعدادات › المشاريع.",
    "noProjects": "لا يوجد مشروع يمكنك تسجيل الوقت عليه",
    "noProjectsBody": "تسجّل الوقت على المشاريع المفتوحة التي أنت عضو نشط في فريقها ويكون تسجيل الوقت فيها مفعّلًا. اطلب من مدير المشروع إضافتك إلى الفريق.",
    "noProjectsShort": "لست عضوًا في مشروع يمكنك تسجيل الوقت عليه."
  },
  "week": {
    "range": "{{from}} – {{to}}",
    "this": "هذا الأسبوع",
    "nav": "الأسبوع",
    "previous": "الأسبوع السابق",
    "next": "الأسبوع التالي"
  },
  "view": {
    "label": "العرض",
    "week": "عرض أسبوعي",
    "day": "عرض يومي"
  },
  "figures": {
    "label": "ساعات هذا الأسبوع",
    "week": "مجموع الأسبوع"
  },
  "submit": {
    "button": "إرسال الأسبوع للاعتماد",
    "title": "إرسال {{hours}} للاعتماد؟",
    "body_zero": "لا توجد سجلات وقت مسودة أو مُرجَعة في {{week}}.",
    "body_one": "يُرسَل سجل وقت واحد (مسودة أو مُرجَع) من {{week}} إلى معتمدي المشروع، ولا يمكنك تعديله ما لم يُرجَع إليك.",
    "body_two": "يُرسَل سجلّا وقت (مسودة أو مُرجَعان) من {{week}} إلى معتمدي المشاريع، ولا يمكنك تعديلهما ما لم يُرجَعا إليك.",
    "body_few": "تُرسَل {{n}} سجلات وقت (مسودات أو مُرجَعة) من {{week}} إلى معتمدي المشاريع، ولا يمكنك تعديلها ما لم تُرجَع إليك.",
    "body_many": "يُرسَل {{n}} سجل وقت (مسودات أو مُرجَعة) من {{week}} إلى معتمدي المشاريع، ولا يمكنك تعديلها ما لم تُرجَع إليك.",
    "body_other": "يُرسَل {{n}} سجل وقت (مسودات أو مُرجَعة) من {{week}} إلى معتمدي المشاريع، ولا يمكنك تعديلها ما لم تُرجَع إليك.",
    "saveFirst": "تُحفظ تغييراتك في الجدول أولًا.",
    "confirm": "إرسال الأسبوع",
    "saveAndSubmit": "حفظ وإرسال",
    "toast_zero": "لم يُرسَل أي سجل وقت",
    "toast_one": "أُرسل سجل وقت واحد ({{hours}})",
    "toast_two": "أُرسل سجلّا وقت ({{hours}})",
    "toast_few": "أُرسلت {{n}} سجلات وقت ({{hours}})",
    "toast_many": "أُرسل {{n}} سجل وقت ({{hours}})",
    "toast_other": "أُرسل {{n}} سجل وقت ({{hours}})",
    "nothing": "لا يوجد وقت مسودة أو مُرجَع لإرساله هذا الأسبوع.",
    "locked_zero": "لا توجد سجلات وقت مقفلة قبل {{date}}.",
    "locked_one": "يبقى سجل وقت واحد قبل {{date}} مسودة: يومه مقفل.",
    "locked_two": "يبقى سجلّا وقت قبل {{date}} مسودتين: يوماهما مقفلان.",
    "locked_few": "تبقى {{n}} سجلات وقت قبل {{date}} مسودات: أيامها مقفلة.",
    "locked_many": "يبقى {{n}} سجل وقت قبل {{date}} مسودات: أيامها مقفلة.",
    "locked_other": "يبقى {{n}} سجل وقت قبل {{date}} مسودات: أيامها مقفلة.",
    "stayed_zero": "لم يبقَ أي سجل وقت مسودة.",
    "stayed_one": "بقي سجل وقت واحد مسودة: يومه مقفل.",
    "stayed_two": "بقي سجلّا وقت مسودتين: يوماهما مقفلان.",
    "stayed_few": "بقيت {{n}} سجلات وقت مسودات: أيامها مقفلة.",
    "stayed_many": "بقي {{n}} سجل وقت مسودات: أيامها مقفلة.",
    "stayed_other": "بقي {{n}} سجل وقت مسودات: أيامها مقفلة."
  },
  "unsaved": {
    "title": "تجاهل الوقت الذي أدخلته؟",
    "body": "التغييرات في الجدول لم تُحفظ بعد.",
    "discard": "تجاهل",
    "keep": "متابعة التعديل"
  },
  "grid": {
    "section": "جدول الأسبوع",
    "label": "وقت الأسبوع",
    "rowHeading": "المشروع › الخطة › المهمة",
    "addRow": "إضافة صف",
    "save": "حفظ",
    "discard": "تجاهل التغييرات",
    "saved": "حُفظ الوقت",
    "unsaved_zero": "لا توجد صفوف معدّلة",
    "unsaved_one": "صف واحد معدّل",
    "unsaved_two": "صفّان معدّلان",
    "unsaved_few": "{{n}} صفوف معدّلة",
    "unsaved_many": "{{n}} صفًا معدّلًا",
    "unsaved_other": "{{n}} صف معدّل",
    "notSaved_zero": "لم يمنع أي سجل وقت الحفظ",
    "notSaved_one": "منع سجل وقت واحد الحفظ",
    "notSaved_two": "منع سجلّا وقت الحفظ",
    "notSaved_few": "منعت {{n}} سجلات وقت الحفظ",
    "notSaved_many": "منع {{n}} سجل وقت الحفظ",
    "notSaved_other": "منع {{n}} سجل وقت الحفظ",
    "notSavedBody": "لم يُحفظ شيء. صحّح الخانات المعلَّمة ثم احفظ مرة أخرى.",
    "alreadyThere": "هذا الصف موجود في الأسبوع.",
    "billable": "للفوترة",
    "billableRow": "قابل للفوترة: {{row}}",
    "removeRow": "حذف الصف {{row}}",
    "rowOptions": "الفوترة والحذف",
    "several": "عدة سجلات وقت",
    "openDay": "افتح {{day}} لتعديلها",
    "returned": "أُرجع عن {{day}}:",
    "returnReason": "سبب الإرجاع: {{reason}}",
    "noReason": "لم يُذكر سبب.",
    "empty": "لا يوجد وقت مسجّل هذا الأسبوع",
    "emptyBody": "أضف صفًا لمشروع، ثم اكتب الساعات تحت كل يوم.",
    "help": "اكتب الساعات بصيغة 7.5 أو 7:30 أو 7h30. تنقّل بين الخانات بمفاتيح الأسهم، واضغط Enter لاعتماد القيمة أو Escape للتراجع.",
    "lock": {
      "several_zero": "لا توجد سجلات وقت",
      "several_one": "سجل وقت واحد: عدّله من العرض اليومي",
      "several_two": "سجلّا وقت: عدّلهما من العرض اليومي",
      "several_few": "{{n}} سجلات وقت: عدّلها من العرض اليومي",
      "several_many": "{{n}} سجل وقت: عدّلها من العرض اليومي",
      "several_other": "{{n}} سجل وقت: عدّلها من العرض اليومي",
      "SUBMITTED": "مُرسل، بانتظار الاعتماد",
      "APPROVED": "معتمد",
      "entry": "لم يعد بالإمكان تعديل سجل الوقت هذا",
      "notLoggable": "لا يمكنك تسجيل الوقت على هذا المشروع حاليًا",
      "before": "لا يمكن تعديل الوقت قبل {{date}}",
      "after": "لا يمكن تسجيل الوقت بعد {{date}} حتى الآن"
    }
  },
  "addRow": {
    "title": "إضافة صف",
    "description": "اختر المشروع، ويمكنك أيضًا اختيار جزء الخطة والمهمة.",
    "submit": "إضافة الصف"
  },
  "target": {
    "project": "المشروع",
    "projectPlaceholder": "اختر مشروعًا",
    "search": "بحث…",
    "noProjects": "لا يوجد مشروع مطابق.",
    "node": "جزء الخطة",
    "nodeHint": "اختياري: المرحلة أو حزمة العمل.",
    "nodePlaceholder": "المشروع كاملًا",
    "noNodes": "لا يوجد جزء مطابق في الخطة.",
    "noNode": "المشروع كاملًا",
    "task": "المهمة",
    "taskRequired": "يُسجَّل الوقت في هذا المشروع على مهمة.",
    "taskPlaceholder": "بدون مهمة",
    "noTasks": "لا توجد مهمة مطابقة.",
    "noTask": "بدون مهمة",
    "restrictedTask": "(مهمة مقيّدة)"
  },
  "log": {
    "title": "تسجيل الوقت",
    "editTitle": "تعديل الوقت",
    "description": "الساعات التي عملتها على مشروع، ويعتمدها مديرك.",
    "date": "التاريخ",
    "hours": "الساعات",
    "hoursHint": "7.5 أو 7:30 أو 7h30",
    "note": "ملاحظة",
    "billable": "قابل للفوترة على العميل",
    "billableFixed": "قابل للفوترة: هذا المشروع يفوتر وقته.",
    "notBillableFixed": "غير مفوتر: هذا المشروع لا يفوتر الوقت.",
    "returned": "أُرجع إليك",
    "notOnProject": "لا يمكنك تسجيل الوقت على مشروع هذه المهمة. اختر مشروعًا آخر.",
    "submit": "تسجيل الوقت",
    "save": "حفظ",
    "errors": {
      "project": "اختر مشروعًا.",
      "task": "اختر مهمة: يُسجَّل الوقت في هذا المشروع على المهام.",
      "hours": "أدخل الساعات بصيغة 7.5 أو 7:30 أو 7h30، بحد أقصى 24 ساعة.",
      "hoursRequired": "أدخل الساعات."
    },
    "toast": {
      "logged": "سُجّل {{hours}}",
      "saved": "حُفظ الوقت"
    }
  },
  "day": {
    "section": "القائمة اليومية",
    "days": "أيام الأسبوع",
    "none": "لا يوجد وقت",
    "log": "تسجيل الوقت",
    "empty": "لا يوجد وقت مسجّل يوم {{day}}",
    "entries": "الوقت المسجّل يوم {{day}}"
  },
  "entry": {
    "billable": "قابل للفوترة",
    "notBillable": "غير قابل للفوترة",
    "returned": "أُرجع:",
    "edit": "تعديل",
    "editLabel": "تعديل {{hours}} على {{project}}",
    "delete": "حذف",
    "deleteLabel": "حذف {{hours}} على {{project}}",
    "deleteTitle": "حذف {{hours}}؟",
    "deleteBody": "سيُحذف سجل الوقت ليوم {{day}}.",
    "deleted": "حُذف الوقت"
  },
  "approvals": {
    "title": "اعتماد الوقت",
    "intro": "الوقت الذي ينتظر قرارك، حسب الشخص والأسبوع.",
    "meta_zero": "لا توجد سجلات وقت بانتظار القرار",
    "meta_one": "سجل وقت واحد بانتظار القرار",
    "meta_two": "سجلّا وقت بانتظار القرار",
    "meta_few": "{{n}} سجلات وقت بانتظار القرار",
    "meta_many": "{{n}} سجل وقت بانتظار القرار",
    "meta_other": "{{n}} سجل وقت بانتظار القرار",
    "empty": "لا يوجد وقت بانتظار اعتمادك",
    "emptyBody": "يظهر هنا الوقت المُرسل على مشاريعك.",
    "groupLabel": "وقت {{person}}، {{week}}",
    "total": "الإجمالي",
    "billable": "قابل للفوترة",
    "selfGroup": "هذا وقتك: يعتمده شخص آخر.",
    "self": "هذا وقتك: يعتمده شخص آخر",
    "cannot": "لا يمكنك البتّ في سجل الوقت هذا",
    "selectGroup": "تحديد كل سجلات وقت {{person}}",
    "selectEntry": "تحديد {{hours}} يوم {{day}}، {{project}}",
    "selected_zero": "لم يُحدَّد أي سجل وقت",
    "selected_one": "سجل وقت واحد محدد · {{hours}}",
    "selected_two": "سجلّا وقت محددان · {{hours}}",
    "selected_few": "{{n}} سجلات وقت محددة · {{hours}}",
    "selected_many": "{{n}} سجل وقت محدد · {{hours}}",
    "selected_other": "{{n}} سجل وقت محدد · {{hours}}",
    "approve": "اعتماد المحدد",
    "return": "إرجاع…",
    "approved_zero": "لم يُعتمد أي سجل وقت",
    "approved_one": "اعتُمد سجل وقت واحد ({{hours}})",
    "approved_two": "اعتُمد سجلّا وقت ({{hours}})",
    "approved_few": "اعتُمدت {{n}} سجلات وقت ({{hours}})",
    "approved_many": "اعتُمد {{n}} سجل وقت ({{hours}})",
    "approved_other": "اعتُمد {{n}} سجل وقت ({{hours}})",
    "returnTitle_zero": "لا توجد سجلات وقت للإرجاع",
    "returnTitle_one": "إرجاع سجل وقت واحد؟",
    "returnTitle_two": "إرجاع سجلَّي وقت؟",
    "returnTitle_few": "إرجاع {{n}} سجلات وقت؟",
    "returnTitle_many": "إرجاع {{n}} سجل وقت؟",
    "returnTitle_other": "إرجاع {{n}} سجل وقت؟",
    "returnBody": "يرى صاحب الوقت سببك، فيصحّح الوقت ويرسله مرة أخرى.",
    "reason": "السبب",
    "reasonHint": "اذكر ما يجب تعديله.",
    "reasonRequired": "اذكر ما يجب تعديله.",
    "returnConfirm": "إرجاع",
    "returned_zero": "لم يُرجَع أي سجل وقت",
    "returned_one": "أُرجع سجل وقت واحد",
    "returned_two": "أُرجع سجلّا وقت",
    "returned_few": "أُرجعت {{n}} سجلات وقت",
    "returned_many": "أُرجع {{n}} سجل وقت",
    "returned_other": "أُرجع {{n}} سجل وقت",
    "notDecided_zero": "لم يمنع أي سجل وقت القرار",
    "notDecided_one": "منع سجل وقت واحد القرار",
    "notDecided_two": "منع سجلّا وقت القرار",
    "notDecided_few": "منعت {{n}} سجلات وقت القرار",
    "notDecided_many": "منع {{n}} سجل وقت القرار",
    "notDecided_other": "منع {{n}} سجل وقت القرار",
    "notDecidedBody": "لم يُتخذ أي قرار. استبعد سجلات الوقت المعلَّمة ثم حاول مرة أخرى.",
    "badge_zero": "لا توجد سجلات وقت بانتظار القرار",
    "badge_one": "سجل وقت واحد بانتظار القرار",
    "badge_two": "سجلّا وقت بانتظار القرار",
    "badge_few": "{{n}} سجلات وقت بانتظار القرار",
    "badge_many": "{{n}} سجل وقت بانتظار القرار",
    "badge_other": "{{n}} سجل وقت بانتظار القرار",
    "columns": {
      "date": "التاريخ",
      "work": "المشروع › الخطة › المهمة",
      "billable": "الفوترة",
      "hours": "الساعات"
    },
    "changed": "تغيّر بعض سجلات الوقت هذه منذ فتحت القائمة. حُدّثت القائمة: راجعها ثم قرّر مرة أخرى.",
    "truncated": "تُعرض أول 2,000 سجل وقت فقط. اختر مشروعًا لرؤية البقية.",
    "project": "المشروع",
    "allProjects": "كل المشاريع"
  },
  "logTime": {
    "button": "تسجيل الوقت",
    "forTask": "تسجيل الوقت على {{number}}"
  },
  "taskHours": {
    "title": "الوقت المسجّل",
    "approved": "معتمد",
    "submitted": "بانتظار الاعتماد",
    "people": "الأشخاص"
  },
  "errors": {
    "PROJECT_NOT_MEMBER": "لا يسجّل الوقت على هذا المشروع إلا أعضاء فريقه النشطون. اطلب من مديره إضافتك.",
    "SELF_APPROVAL": "لا يعتمد أحد وقته بنفسه: يبتّ فيه شخص آخر.",
    "TIME_ENTRY_BILLED": "هذا الوقت مُدرج في فاتورة عميل. ألغِ الفاتورة أولًا.",
    "TIME_ENTRY_POSTED": "هذا الوقت مُدرج في ترحيل تكلفة العمالة. ألغِ الترحيل أولًا.",
    "TIME_ENTRY_ILLEGAL_MOVE": "تغيّرت حالة سجل الوقت هذا منذ فتحته: حدّث الصفحة وتحقق منها.",
    "TIME_DATE_LOCKED": "هذا اليوم خارج الفترة التي يمكن تسجيل الوقت فيها أو تعديله.",
    "minutes": "تحقق من الساعات: لا يتجاوز اليوم 24 ساعة.",
    "task": "اختر مهمة من مهام هذا المشروع تستطيع رؤيتها.",
    "item": "تعذّر حفظ سجل الوقت هذا."
  }
}
